module.exports = __webpack_public_path__ + "img/create.f92e8a46.png";